(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var Cookies = function Cookies() {
        this.allowed = this.getCookie('cookies_allowed');

        this.$cookiesPanel = document.querySelector('#cookies-panel');
        if (this.$cookiesPanel) {
            this.$cookiesPanelInner = this.$cookiesPanel.querySelector('.cookies-panel-inner');
            this.$declineBtn = this.$cookiesPanel.querySelector('.cookies-panel-btn--decline');
            this.$allowBtn = this.$cookiesPanel.querySelector('.cookies-panel-btn--allow');
            this.$minimiseBtn = this.$cookiesPanel.querySelector('.cookies-panel-min-btn');
            this.$maximiseBtn = this.$cookiesPanel.querySelector('.cookies-panel-max-btn');
        }

        this.$deleteCookiesBtns = document.querySelectorAll('.js-delete-cookies');

        this.initEvents();

        if (this.allowed === 'yes') {
            this.allowCookies();
        }
    };

    Cookies.prototype.initEvents = function initEvents () {
        var that = this;

        if (this.$cookiesPanel) {
            if (this.$allowBtn) {
                this.$allowBtn.addEventListener('click', function (e) {
                    e.preventDefault();

                    that.hideCookiesPanel();
                    that.setCookie('cookies_allowed', 'yes');
                    window.dispatchEvent(new Event('cookies_allowed'));
                });
            }

            if (this.$declineBtn) {
                this.$declineBtn.addEventListener('click', function (e) {
                    e.preventDefault();

                    that.hideCookiesPanel();
                    that.setCookie('cookies_allowed', 'no');
                    window.dispatchEvent(new Event('cookies_declined'));
                });
            }

            if (this.$minimiseBtn) {
                this.$minimiseBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    that.minifyCookiesPanel();
                });
            }

            if (this.$maximiseBtn) {
                this.$maximiseBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    that.maximizeCookiesPanel();
                });
            }

            window.addEventListener('cookies_allowed', function () {
                that.allowCookies();
            });
        }

        if (this.$deleteCookiesBtns) {
            this.$deleteCookiesBtns.forEach(function ($deleteCookiesBtn) {
                $deleteCookiesBtn.addEventListener('click', function (e) {
                    e.preventDefault();

                    that.deleteCookie('cookies_allowed');
                    window.location = window.location;
                });
            });
        }
    };

    Cookies.prototype.getCookie = function getCookie (cookieName) {
        var re = new RegExp('[; ]' + cookieName + '=([^\\s;]*)');
        var sMatch = (' ' + document.cookie).match(re);

        if (cookieName && sMatch) {
            return unescape(sMatch[1]);
        }

        return '';
    };

    Cookies.prototype.setCookie = function setCookie (cookieName, cookieValue) {
        var name = cookieName;
        var value = cookieValue;
        var d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    };

    Cookies.prototype.deleteCookie = function deleteCookie (cookieName) {
        var name = cookieName;
        var d = new Date();
        d.setTime(d.getTime() - 10);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=;' + expires + ';path=/';
    };

    Cookies.prototype.hideCookiesPanel = function hideCookiesPanel () {
        var that = this;

        this.$cookiesPanel.classList.add('hide');
        this.$cookiesPanel.addEventListener('transitionend', function () {
            that.$cookiesPanel.remove();
        });
    };

    Cookies.prototype.minifyCookiesPanel = function minifyCookiesPanel () {
        var that = this;

        this.$cookiesPanelInner.style.height = this.$cookiesPanelInner.clientHeight + 'px';
        this.$cookiesPanelInner.style.width = this.$cookiesPanelInner.clientWidth + 'px';

        setTimeout(function () {
            that.$cookiesPanel.classList.add('minify');
        }, 10);
    };

    Cookies.prototype.maximizeCookiesPanel = function maximizeCookiesPanel () {
        var that = this;

        this.$cookiesPanel.classList.remove('minify');

        var onTransitionEnd = function () {
            that.$cookiesPanelInner.style.height = '';
            that.$cookiesPanelInner.style.width = '';

            that.$cookiesPanel.removeEventListener('transitionend', onTransitionEnd);
        };

        this.$cookiesPanel.addEventListener('transitionend', onTransitionEnd);
    };

    Cookies.prototype.allowCookies = function allowCookies () {
        this.initAnalytics();
    };

    Cookies.prototype.initAnalytics = function initAnalytics () {
        if (typeof ga_id !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            this.gtag('js', new Date());
            this.gtag('config', ga_id);
        }
    };

    Cookies.prototype.gtag = function gtag () {
        dataLayer.push(arguments);
    };

    (function ($) {
        new Cookies();
    })(jQuery);

})));
//# sourceMappingURL=tauxpremier.min.js.map
